import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_AIRBYTE_TOKEN_LOG: TDatadogErrorLog = {
  from: 'src/contexts/AirbyteContext',
  name: 'Get Airbyte Token',
  message: 'Fetch airbyte token failed',
}
